import './assets/js/config.js'

/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
    //剪切板

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
    // UI组件
import ElementUI from 'element-ui'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
    // 接口
import protocol from './assets/js/trans/protocol.js'
import http from './assets/js/trans/http.js'
import hqProtocol from './assets/js/hq/hqProtocol.js'
import protocolTrans from './assets/js/trans/protocolTrans.js'

// 获取hqc配置
function $getHQConfig() {
    const excludeAppNames = ['景陶易购', '贵茶茗汇', '茗贵e购', '楚云农商', '神农购销', '景瓷兴', '长江国际']
    if (!excludeAppNames.includes(window.g.APP_WINNY_NAME)) {
        localStorage.setItem('hqcConfig', null)
        return
    }
    if(!$getHQConfig.isCooling){
        $getHQConfig.isCooling = true
        $getHQConfig.timer = setTimeout(() => {
            $getHQConfig.isCooling = false;
            $getHQConfig.timer = null;
        }, 10000)
    } else {
        // 如果在冷却期内，直接返回不执行请求
        return;
    }
    http.postFront(protocol.param_queryItemConfigs).then((res)=>{
        const { code, value } = res.data
        if (code === '0') {
            const hqcConfig = value.map(item => {
                const itemContent = JSON.parse(item.itemContent)
                return itemContent
            })
            localStorage.setItem('hqcConfig', JSON.stringify(hqcConfig))
        } else {
            localStorage.setItem('hqcConfig', null)
        }
    })
}
// 初始化静态属性
$getHQConfig.isCooling = false;
$getHQConfig.timer = null;

import { hqWs } from './assets/js/hq/hqWs.js'
global.protocol = protocol

global.http = http
global.hqProtocol = hqProtocol
global.hqWs = hqWs
global.router = router
global.protocolTrans = protocolTrans
    // tool
import * as util from './assets/common/util.js'
global.util = util
Vue.prototype.util = util
    // pdf下载
import pdfDownload from './assets/common/pdfDownload'
global.pdfDownload = pdfDownload
import './directives'
//
// 引入filter
import vueFilter from './filters/filter'
// 遍历所有方法
Object.keys(vueFilter).forEach(key => {
        Vue.filter(key, vueFilter[key])
    })
    //全局回调函数
Vue.prototype.each = (arr, fn) => {
        for (var i = 0; i < arr.length; i++) {
            fn(arr[i])
        }
    }
    //判断并修改各种数据的值
Vue.prototype.modifyData = (arrIndex, arrProperty, judgeCondition, str, str2) => {
        if (arrIndex[arrProperty] == judgeCondition) { arrIndex[arrProperty] = str; } else { arrIndex[arrProperty] = str2 || arrIndex[arrProperty]; }
    }
    //判断并转换时间戳
Vue.prototype.modifyTime = (arrIndex, arrProperty, newProperty) => {
  // 判断是时间戳在处理
      if (/^\d{10,13}$/.test(arrIndex[arrProperty])) {
        if (newProperty) { arrIndex[newProperty] = Vue.prototype.DateFormate(Number(arrIndex[arrProperty])); return };
        arrIndex[arrProperty] = Vue.prototype.DateFormate(Number(arrIndex[arrProperty]));
      }
    }



    //读取cookie
Vue.prototype.getCookie = (name) => {
        var arr,
            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
        else return null;
    }


    //时间戳转换(具体)
Vue.prototype.DateFormate = (timer) => {
        // var timezone = 8; //目标时区时间，东八区
        // var offset_GMT = new Date().getTimezoneOffset();
        // var offset_GMT_Time = -offset_GMT/60;
        // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
        var newTimer = timer
        var date = new Date(newTimer);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var min = date.getMinutes();
        var sec = date.getSeconds();
        [year, month, day, hour, min, sec] = [year, month, day, hour, min, sec].map(item => item < 10 ? "0" + item : item);
        // return `${year}-${month}-${day} ${hour}:${min}:${sec}`;
        return `${year}-${month}-${day}  ${hour}:${min}:${sec}`;
    }
    //判断字段设置样式
Vue.prototype.setStrClass = (el, val, class1, class2) => el.indexOf(val) != -1 ? class1 : class2;
// 钩子函数,登录状态检查
router.beforeEach((to, from, next) => {
    const targetRouterList = ['/quotationList', '/transcc', '/myAssetNew', '/reportSystem', '/warehouseSys', '/settlementSystem']
    if (targetRouterList.includes(to.path)) {
        $getHQConfig()
    }
    if (to.meta.isIndex) {
        store.commit('changeIsIndex', true)
    } else {
        store.commit('changeIsIndex', false)
    }
    if (sessionStorage.getItem('sessionStr') && sessionStorage.getItem('userId')) {
        const userType = sessionStorage.getItem('userType')
        if (to.meta.requireAuth && userType == 'T') {
            // if (to.meta.requireAuth) {
            const highCerStatus = sessionStorage.getItem('highCerStatus')
            if (to.meta.highCerStatus && highCerStatus != '0') {
                Message({
                    showClose: true,
                    message: 'Please complete Verification and Senior Verification first',
                    type: 'error',
                    duration: 2000
                })
                next({
                    path: '/usercenter/highCertification'
                })
                return
            } else {
                next()
            }
            const nickNameStatus = sessionStorage.getItem('nickNameStatus')
            if (to.meta.nickNameStatus && nickNameStatus != '0') {
                next({
                    path: '/otcstart'
                })
            } else {
                next()
            }
        } else {
            next()
        }
    } else {
        if (to.meta.requireAuth) {
            next({
                path: '/login',
                query: {
                    redirect: (to.fullPath)
                } // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        } else {
            next()
        }
    }
})
ElementUI.Dialog.props.closeOnClickModal.default = false
// //混入全局快捷键
// Vue.mixin({
//   data(){
//     return{
//       tq_onKeyCode_A:false,
//       tq_onKeyCode_Shift:false,
//       tq_onKeyCode_Ctrl:false,
//       tq_onKeyCode_Alt:false,
//       tq_onKeyCode_F1:false,
//       tq_onKeyCode_F2:false,
//       tq_onKeyCode_F3:false,
//       tq_onKeyCode_F4:false,
//     }
//   },
//   created(){
//     let _this = this
//     document.onkeydown = function(e){
//       let evn = e || event ;
//       let key = evn.keyCode || evn.which || evn.charCode ;
//       // A
//       if(key === 65){
//         _this.tq_onKeyCode_A = true ;
//       }
//       // Shift
//       if(key === 16){
//         _this.tq_onKeyCode_Shift = true;
//       }
//       // Ctrl
//       if(key === 17){
//         _this.tq_onKeyCode_Ctrl = true;
//       }
//       // Alt
//       if(key === 18){
//         _this.tq_onKeyCode_Alt = true;
//       }
//       // F1
//       if(key === 112){
//         _this.tq_onKeyCode_Alt = true;
//         _this.shortcuts_F1()
//       }
//       // F2
//       if(key === 113){
//         _this.tq_onKeyCode_Alt = true;
//         _this.shortcuts_F2()
//       }
//       // F3
//       if(key === 114){
//         _this.tq_onKeyCode_Alt = true;
//         _this.shortcuts_F3()
//       }
//       // F4
//       if(key === 115){
//         _this.tq_onKeyCode_Alt = true;
//         _this.shortcuts_F4()
//       }
//       // if(_this.tq_onKeyCode_Shift === true && _this.tq_onKeyCode_Ctrl === true && _this.tq_onKeyCode_A === true){
//       //   _this.tq_onKeyCode_Ctrl = false
//       //   _this.tq_onKeyCode_Shift = false
//       //   _this.tq_onKeyCode_A = false
//       //   _this.shortcuts_Ctrl_Shift_A()
//       // }
//     }
//     document.onkeyup = function(e){
//       if (e.keyCode === 65) {
//         _this.tq_onKeyCode_A = false
//       }
//       if (e.keyCode === 16) {
//         _this.tq_onKeyCode_Shift = false
//       }
//       if (e.keyCode === 17) {
//         _this.tq_onKeyCode_Ctrl = false
//       }
//       if (e.keyCode === 18) {
//         _this.tq_onKeyCode_Alt = false
//       }
//       if (e.keyCode === 112) {
//         _this.tq_onKeyCode_F1 = false
//       }
//       if (e.keyCode === 113) {
//         _this.tq_onKeyCode_F2 = false
//       }
//       if (e.keyCode === 114) {
//         _this.tq_onKeyCode_F3 = false
//       }
//       if (e.keyCode === 115) {
//         _this.tq_onKeyCode_F4 = false
//       }
//     }
//   },
//   methods:{
//     shortcuts_Ctrl_Shift_A(event){
//       // if(event.keyCode==16){
//       //   alert('shift')
//       // }
//       alert('Ctrl+Shift+A');
//     },
//     shortcuts_F1(event){
//       // this.$refs.trade_input_buy_quality.focus()
//     },
//     shortcuts_F2(event){
//       // this.$refs.trade_input_buy_amount.focus()
//     },
//     shortcuts_F3(event){
//       // this.$refs.trade_input_sell_quality.focus()
//     },
//     shortcuts_F4(event){
//       // this.$refs.trade_input_sell_amount.focus()
//     },

//   },
// })

import BaseApi from './assets/baseServe/baseServe'
global.BaseApi = BaseApi
if (process.env.NODE_ENV !== 'production') {
    Vue.config.performance = true
}
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')